import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'mstar-content-container',
  templateUrl: './content-container.component.html',
  styleUrls: ['./content-container.component.css']
})
export class ContentContainerComponent implements OnInit {

  @Input() desktopWidth = 90;

  constructor() { }

  ngOnInit() {
  }

}
